import axios from "axios";

const CACHE_KEY = "usd_brl_rate";
const TTL_MS = 24 * 60 * 60 * 1000; // 24h

function readCache() {
    try {
        const raw = localStorage.getItem(CACHE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
}

/**
 * USD→BRL rate, cached in localStorage for 24h. Falls back to any (even stale)
 * cached value if the fetch fails, or null if nothing is available.
 */
export async function loadUsdToBrl() {
    const cached = readCache();
    if (cached?.rate && cached?.ts && Date.now() - cached.ts < TTL_MS) {
        return cached.rate;
    }

    try {
        const res = await axios.get("https://economia.awesomeapi.com.br/last/USD-BRL");
        const rate = parseFloat(res?.data?.USDBRL?.bid);
        if (rate && isFinite(rate)) {
            localStorage.setItem(CACHE_KEY, JSON.stringify({ rate, ts: Date.now() }));
            return rate;
        }
    } catch (e) {
        // ignore — fall back to stale cache below
    }

    return cached?.rate || null;
}
